import type { Router } from 'vue-router'
import { installRouteNavigationLock } from '~/utils/routeNavigationLock.mjs'

export default defineNuxtPlugin(nuxtApp => {
  const router = nuxtApp.$router as Router | undefined
  if (!router) {
    return
  }
  let shouldScrollTopAfterPageReady = false
  const routeNavigationLoading = useRouteNavigationLoading()
  const finishRouteNavigation = installRouteNavigationLock(router, locked => {
    routeNavigationLoading.value = locked
  })

  router.afterEach((to, from, failure) => {
    if (failure) {
      return
    }

    // 同一路径（query/hash 变化）交由页面业务逻辑处理
    if (to.path === from.path) {
      shouldScrollTopAfterPageReady = false
      return
    }

    shouldScrollTopAfterPageReady = true
  })

  nuxtApp.hook('page:finish', () => {
    if (!import.meta.client) {
      return
    }
    finishRouteNavigation()
    if (!shouldScrollTopAfterPageReady) {
      return
    }
    shouldScrollTopAfterPageReady = false
    window.requestAnimationFrame(() => {
      window.scrollTo({ left: 0, top: 0, behavior: 'auto' })
    })
  })

  nuxtApp.hook('app:error', () => {
    finishRouteNavigation()
    shouldScrollTopAfterPageReady = false
  })
})
